"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (function () {
    window.requestIdleCallback =
        window.requestIdleCallback ||
            function (callback) {
                var start = Date.now();
                return setTimeout(function () {
                    callback({
                        didTimeout: false,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - start));
                        },
                    });
                }, 1);
            };
})();
//# sourceMappingURL=request-idle-callback.js.map